import { render, staticRenderFns } from "./b_BookDirectly.vue?vue&type=template&id=20bea07f&scoped=true&"
import script from "./b_BookDirectly.vue?vue&type=script&lang=js&"
export * from "./b_BookDirectly.vue?vue&type=script&lang=js&"
import style0 from "./b_BookDirectly.vue?vue&type=style&index=0&id=20bea07f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bea07f",
  null
  
)

export default component.exports